import styles from './Stepper.module.scss';
import cn from 'classnames';
import XIcon from '@assets/icons/outline/x.svg?react';
import CheckIcon from '@assets/icons/outline/check.svg?react';
import { EStepState, IStepperProps, TStep } from './types';
import { SubTitle1, Title2 } from '@components/new/Typo';

const Stepper = (props: IStepperProps) => {
  const { steps, gap } = props;

  return (
      <div className={styles.stepper}>
        {steps.map((item: TStep, index: number) => {
          const conditionDisabled: boolean = item.state === EStepState.DISABLED;
          const conditionEnabled: boolean = item.state === EStepState.ENABLED;
          const conditionError: boolean = item.state === EStepState.ERROR;
          const conditionSuccess: boolean = item.state === EStepState.SUCCESS;

          return (
              <div
                  className={cn(
                    styles.step,
                    styles[`gap-${gap ?? "auto"}`],
                    !conditionDisabled && styles.stepPassed,
                  )}
                  key={index}
                  style={{ zIndex: steps.length - index }}
              >
                <button
                    className={styles.action}
                    disabled={conditionDisabled}
                >
                  <span
                      className={cn(styles.indicator, {
                        [styles.indicatorDisabled]: conditionDisabled,
                        [styles.indicatorEnabled]: conditionEnabled,
                        [styles.indicatorError]: conditionError,
                        [styles.indicatorSuccess]: conditionSuccess
                      })}
                  >
                    {conditionSuccess ? (
                      <CheckIcon />
                    ) : (conditionError ? (
                      <XIcon />
                    ) : (
                      <SubTitle1>{index + 1}</SubTitle1>
                    ))}
                  </span>
                  <Title2>
                    {item.text}
                  </Title2>
                </button>
              </div>
          );
        })}
      </div>
  );
};

export default Stepper;
